import { render, staticRenderFns } from "./ProductionScanIndex.vue?vue&type=template&id=4781b970&scoped=true&"
import script from "./ProductionScanIndex.vue?vue&type=script&lang=js&"
export * from "./ProductionScanIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProductionScanIndex.vue?vue&type=style&index=0&id=4781b970&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4781b970",
  null
  
)

export default component.exports